/**
 * Lazy mount for the Home workshop vignette. three.js only downloads when the
 * Home hero is actually on screen; without WebGL (or on a renderer crash) it
 * degrades SILENTLY — the host card keeps its stage gradient and caption, so
 * nothing looks broken. Honors `prefers-reduced-motion` by rendering a single
 * static frame.
 */
import { lazy, Suspense, useState } from 'react'
import { usePrefersReducedMotion } from '../../hooks/use-prefers-reduced-motion'
import { SilentBoundary, supportsWebGL } from '../WebglGuard'

const DioramaScene = lazy(() => import('./DioramaScene'))

export function HomeDiorama({ busy }: { busy: boolean }) {
  const reduced = usePrefersReducedMotion()
  const [webgl] = useState(supportsWebGL)
  if (!webgl) return null
  return (
    <SilentBoundary>
      <Suspense fallback={null}>
        <DioramaScene motion={!reduced} busy={busy} />
      </Suspense>
    </SilentBoundary>
  )
}
